<nav class="menu-bar">

  <a *ngIf="!router.url.startsWith('/join')" routerLink="/dashboard">
    <div class="logo"><img src="{{ ownerLogoUrl }}" /></div>
  </a>

  <ul>

    <a *ngIf="canViewDevice " routerLink="/devices" routerLinkActive="active">
      <li i18n="@@header_your_devices">Dispositivi</li>
    </a>

    <a *ngIf="!isAdmin() && !isService() && canViewExecution" routerLink="/executions"
      routerLinkActive="active">
      <li i18n="@@header_executions">Automatismi</li>
    </a>

    <a *ngIf="!isAdmin() && !isService() && canViewUser" routerLink="/users" routerLinkActive="active">
      <li i18n="@@header_your_users">Abbonamenti</li>
    </a>

    <a *ngIf="!isAdmin() && !isService() && canViewGroup" routerLink="/groups"
      routerLinkActive="active">
      <li i18n="@@header_groups">Gruppi</li>
    </a>

    <!-- <a *ngIf="showAppOpen && isLoggedIn()" routerLink="/open" routerLinkActive="active">
      <li i18n="@@header_app_open">Configura App</li>
    </a> -->

    <a *ngIf="isAdmin() || isService()" routerLink="/owners" routerLinkActive="active">
      <li i18n="@@header_owners">Gestori</li>
    </a>

    <a *ngIf="canViewOperation" routerLink="/operationLog" routerLinkActive="active">
      <li i18n="@@header_operationLog">Registro operazioni</li>
    </a>

    <!-- <a *ngIf="isLoggedIn()" routerLink="/profile" routerLinkActive="active">
      <li i18n="@@header_profile">Profilo</li>
    </a> -->

    <a *ngIf="!isAdmin() && !isService() && canViewAlias" routerLink="/aliases"
      routerLinkActive="active">
      <li i18n="@@header_alias">Operatori</li>
    </a>

    <a *ngIf="!isAdmin() && !isService() && canViewRequests" routerLink="/requests"
    routerLinkActive="active">
    <li i18n="@@header_requests">Richieste</li>
  </a>


    <!-- rimosso per ripensamento di Marchetti, lo tengo da parte momentaneamente 
    <a *ngIf="showEnterAsAliasButton()" (click)="logout()" routerLinkActive="active">
      <li i18n="@@header_enter_as_alias"> Accedi come Alias</li>
    </a> -->

    <a *ngIf="showEnterOtherDevicesButton()" (click)="logout()" routerLinkActive="active">
      <li i18n="@@header_enter_other_devices"> Accedi ad altri impianti</li>
    </a>

    <!-- 29/05/24 prima era && isPilomatDev() ora disponibile per bruzzo -->
    <a *ngIf="isAdmin()" routerLink="/ota" routerLinkActive="active">
      <li>OTA</li>
    </a>

    <a *ngIf="isLoggedIn()" (click)="logout()" routerLinkActive="active">
      <li i18n="@@header_logout">Esci</li>
    </a>

    <li id="lang">
      <div class="dropdown">
        <a class="js-link js-lang" [matMenuTriggerFor]="langMenu">
          <fa-icon icon="globe"></fa-icon>
          <fa-icon icon="sort-down" class="float-right"></fa-icon>
        </a>
      </div>
    </li>

    <mat-menu #langMenu="matMenu">
      <button mat-menu-item (click)="languageSelect('en')">
        <a href="/{{serverFolder}}/en/#/"><img src="assets/img/lang/en.png"><span>EN</span></a>
      </button>
      <button mat-menu-item (click)="languageSelect('fr')">
        <a href="/{{serverFolder}}/fr/#/"><img src="assets/img/lang/fr.png"><span>FR</span></a>
      </button>
      <button mat-menu-item (click)="languageSelect('de')">
        <a href="/{{serverFolder}}/de/#/"><img src="assets/img/lang/de.png"><span>DE</span></a>
      </button>
      <button mat-menu-item (click)="languageSelect('it')">
        <a href="/{{serverFolder}}/it/#/"><img src="assets/img/lang/it.png"><span>IT</span></a>
      </button>
      <button mat-menu-item (click)="languageSelect('es')">
        <a href="/{{serverFolder}}/es/#/"><img src="assets/img/lang/es.png"><span>ES</span></a>
      </button>
      <button mat-menu-item (click)="languageSelect('fl')">
        <a href="/{{serverFolder}}/nl/#/"><img src="assets/img/lang/fl.png"><span>FL</span></a>
      </button>
    </mat-menu>

  </ul>

</nav>